export default __webpack_public_path__ + "static/media/StraightenedWires.901f14fc.jpg";